const ClickToViewState = {
  Hidden: 1,
  Processing: 2,
  Visible: 3,
};

export default ClickToViewState;
